import React from "react";
import { AdsSlotProps } from "./Ads.Slot";
import AdsSlotEngine from "./Ads.Slot.Engine";

const urlMapRegex = {
  "/$": "home",
  "^/ultimas.*": "ultimas",
  "^/geral.*": "geral",
  "^/emprego.*": "emprego",
  "^/esporte.*": "esporte",
  "^/famosos.*": "famosos",
  "^/meu-bichinho.*": "meu-bichinho",
  "^/loterias.*": "loterias",
  "^/gata-do-daqui.*": "gata-do-daqui",
  "^/promocoes.*": "promocoes",
  "^/infomercial.*": "infomercial",
  "^/novelas.*": "novelas",
  "^/publicidade-legal.*": "publicidade-legal",
  "^/horoscopo.*": "horoscopo",
  "^/pesquisa.*": "pesquisa",
} as const;

type TargetSlotsSection =
  | "Capa - Destaque - Daqui"
  | "Capa - Destaque 2 - Daqui"
  | "Capa - fotão, secundárias e rodapé - Daqui"
  | "Últimas Capa - Daqui"
  | "Capa - Destaque"
  | "Capa de Últimas - Daqui"
  | "Widget Kit GO"
  | "Widget Kit TO"
  | "Últimas Emprego - Daqui"
  | "Widget - Lista Gata do Daqui"
  | "Widget - Lista Loterias"
  | "WhatsApp"
  | "Elementos - Radio Daqui"
  | "Últimas Promocoes - Daqui"
  | "Últimas Geral - Daqui"
  | "Últimas Esporte - Daqui"
  | "Últimas Famosos - Daqui"
  | "Últimas Meu Bichinho - Daqui"
  | "Últimas Loteria - Daqui"
  | "Últimas Gata do Daqui"
  | "Últimas Novelas - Daqui"
  | "Últimas infomercial - Daqui"
  | "Últimas Minha Dica - Daqui"
  | "Últimas Horoscopo"
  | "Lateral - Últimas Daqui"
  | "Promoções 🎁"
  | "Leia também"
  | "Article Slot"
  | "Continue lendo / Mais Lidas"
  | "Geral - título"
  | "Esporte - título"
  | "Famosos - título"
  | "Emprego - título"
  | "Meu bichinho - título"
  | "Loterias - título"
  | "Minha dica é - título"
  | "Gata do Daqui - título"
  | "Promoções - título"
  | "Infomercial - título"
  | "Pesquisa - Lista"
  | "Search Filter"
  | "Search Slot"
  | "Editais - Lista - DAQUI" // publicidade legal
  | "Publicidade Legal - Template Interna Daqui"
  | "Publicidade Legal Daqui- Lateral"
  | "Horóscopo - título"
  | "Expediente - Daqui"
  | "Widget Agendamento"
  | "Matéria - Emprego"
  | "generic";

type SlotPositionType =
  | "BILL_MAXI1"
  | "LEADBRD1"
  | "LEADBRD2"
  | "LEADBRD3"
  | "MPAG1"
  | "MPAG2"
  | "MPAG3"
  | "RM1"
  | "RM2"
  | "RM3"
  | "BILL_MAXI1_M"
  | "RM1_M"
  | "RM2_M"
  | "RM3_M"
  | "MBOX1"
  | "MBOX2"
  | "MBOX3"
  | "MBOX?"
  | "RM?"
  | "MPAG?"
  | "LEADBRD?"
  | "RM?_M"
  | "HTML"
  | "";

type SlotIdDaquiType =
  | "gjc_DAQUI.Home"
  | "gjc_DAQUI"
  | "gjc_DAQUI/Ultimas"
  | "gjc_DAQUI/Geral"
  | "gjc_DAQUI/Famosos"
  | "gjc_DAQUI/Meu_Bichinho"
  | "gjc_DAQUI/Loterias"
  | "gjc_DAQUI/Gata_Do_Daqui"
  | "gjc_DAQUI/Promocoes"
  | "gjc_DAQUI/Infomercial"
  | "gjc_DAQUI/Emprego"
  | "gjc_DAQUI/Esporte"
  | "gjc_DAQUI/Pesquisa"
  | "gjc_DAQUI/Horoscopo"
  | "gjc_DAQUI/Publicidade_Legal"
  | "Alright"
  | "POP_INTERNAS_SMT_RM9999"
  | "POP_INTERNAS_DSK_MBOX9999";

type SectionName = typeof urlMapRegex[keyof typeof urlMapRegex];

type Slot = {
  id: SlotIdDaquiType;
  position: SlotPositionType;
  nthPosition?: Array<Number>; //Slot potion by occurence, like 0, 1, 2, 3... The number represent when to be rendered by ocorrence
};

type DeviceSlotType = {
  desktopSlot?: Slot;
  mobileSlot?: Slot;
};

type PlacementType = {
  [placement in AdsSlotProps["componentReference"]]?: DeviceSlotType;
};

type BlockType = {
  [blockType in AdsSlotProps["type"]]?: PlacementType;
};

type AdsSettings = {
  [section in TargetSlotsSection]: {
    [subsection in SectionName | "*"]?: BlockType;
  };
};

const settings = {
  "Capa - Destaque - Daqui": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Capa - fotão, secundárias e rodapé - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD2",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Capa - Destaque 2 - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM1_M",
          },
        },
      },
    },
  },
  "Geral - título": {
    geral: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Widget Agendamento": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "MPAG1",
          },
        },
      },
    },
  },
  "Últimas Geral - Daqui": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "LEADBRD1",
          },
        },
      },
    },
    geral: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M",
          },
        }
      },
      block: {
        bottom: {
          id: "gjc_DAQUI/Geral",
          position: "LEADBRD1"
        }
      }
    }
  },
  "Capa de Últimas - Daqui": {
    ultimas: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Continue lendo / Mais Lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "MPAG1",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M",
          },
        },
      },
    },
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "MPAG1",
          },
        },
      },
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "MPAG1",
          },
        },
      },
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "MPAG1",
          },
        },
      },
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "MPAG1",
          },
        },
      },
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "MPAG1",
          },
        },
      },
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "MPAG1",
          },
        },
      },
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "MPAG1",
          },
        },
      },
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "MPAG1",
          },
        },
      },
    },
    infomercial: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "MPAG1",
          },
        },
      },
    },
  },
  "Editais - Lista - DAQUI": {
    "publicidade-legal": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "RM1_M",
          },
        },
      },
    },
  },
  "Elementos - Radio Daqui": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: 'gjc_DAQUI.Home',
            position: 'RM3'
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Emprego - título": {
    emprego: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Esporte - título": {
    esporte: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Loterias - título": {
    loterias: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Promoções - título": {
    promocoes: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Pesquisa - Lista": {
    pesquisa: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Gata do Daqui - título": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Famosos - título": {
    famosos: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Publicidade Legal Daqui- Lateral": {
    "publicidade-legal": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "MPAG1",
          },
        },
      },
    },
  },
  "Publicidade Legal - Template Interna Daqui": {
    "publicidade-legal": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Infomercial - título": {
    infomercial: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Meu bichinho - título": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Widget Kit GO": {
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "MPAG1",
          },
          mobileSlot: {
            id: 'gjc_DAQUI/Ultimas',
            position: 'RM1_M'
          }
        },
      },
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM1_M",
          }
        },
      },
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM1_M",
          }
        },
      },
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM1_M",
          }
        },
      },
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM1_M",
          }
        },
      },
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM1_M",
          }
        },
      },
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM1_M",
          }
        },
      },
    },
    "gata-do-daqui": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM1_M",
          }
        },
      },
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM1_M",
          }
        },
      },
    },
    "*": {
      side: {
        top: {
          desktopSlot: {
            id: "Alright",
            position: "HTML",
            customHtml: "<div id='div-gpt-ad-1737038557423-0'></div>",
            customEventName: "div-gpt-ad-1737038557423-0"
          },
        },
      },
    },
  },
  "Widget Kit TO": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M"
          }
        },
      },
    },
  },
  "Widget - Lista Gata do Daqui": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "WhatsApp": {
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "RM2_M",
          }
        }
      },
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM2_M",
          }
        }
      },
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM2_M",
          }
        }
      },
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM2_M",
          }
        }
      },
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM2_M",
          }
        }
      },
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM2_M",
          }
        }
      },
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM2_M",
          }
        }
      },
    },
    "gata-do-daqui": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM2_M",
          }
        }
      },
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM1",
          },
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM2_M",
          }
        }
      },
    },
  },
  "Lateral - Últimas Daqui": {
    emprego: {
      side: {
        bottom: {
          id: "gjc_DAQUI/Emprego",
          position: "RM2"
        }
      }
    } 
  },
  "Últimas Promocoes - Daqui": {
    promocoes: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Gata do Daqui": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Loteria - Daqui": {
    loterias: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Meu Bichinho - Daqui": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1_M",
          },
        },
        block: {
          bottom: {
            desktopSlot: {
              id: "gjc_DAQUI/Meu_Bichinho",
              position: "LEADBRD1",
            },
          },
        }
      },
    },
  },
  "Últimas Esporte - Daqui": {
    esporte: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Emprego - Daqui": {
    emprego: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Famosos - Daqui": {
    famosos: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Últimas Capa - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD3",
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas infomercial - Daqui": {
    infomercial: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Search Filter": {
    "*": {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Search Slot": {
    "*": {
      search: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "MBOX1",
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM1_M",
          },
        },
      },
    },
  },
  "Últimas Horoscopo": {
    horoscopo: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Horóscopo - título": {
    horoscopo: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Matéria - Emprego Daqui": {
    "emprego": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Esporte Daqui": {
    "esporte": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Famosos Daqui": {
    "famosos": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Gata do Daqui": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/GataDoDaqui",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/GataDoDaqui",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Horóscopo Daqui": {
    "horoscopo": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Loterias Daqui": {
    "loterias": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Novelas Daqui": {
    "novelas": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Novelas",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Novelas",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Geral Daqui": {
    "geral": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Meu Bichinho Daqui": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Minha dica e Daqui": {
    "*": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Promoções Daqui": {
    "promocoes": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Informecial Daqui": {
    "infomercial": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Especial_Publicitario",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Especial_Publicitario",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - genérica": {
    "geral": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      article: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "MBOX?",
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM?_M",
          },
        },
      },
    },
  },
  "generic": {
      "*": {
          "article": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "block": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "mega": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "side": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "search": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "newsletter": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
      }
  },
};

type SlotSizes = {
  [slotName: string]: [number, number];
};

type SlotSizeMap = {
  [key in SlotIdDaquiType]?: SlotSizes;
};

const slotSizeMap: SlotSizeMap = {
  "gjc_DAQUI.Home": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Emprego": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Esporte": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Famosos": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Gata_Do_Daqui": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Geral": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Horoscopo": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Infomercial": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Loterias": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Meu_Bichinho": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Pesquisa": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Promocoes": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Publicidade_Legal": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_DAQUI/Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
};

const AdsSlot: React.FC<AdsSlotProps> = ({
  type,
  componentReference = "bottom",
  data,
}) => {
  return (
    <AdsSlotEngine
      settings={settings}
      urlMapRegex={urlMapRegex}
      slotSizeMap={slotSizeMap}
      type={type}
      componentReference={componentReference}
      data={data}
    />
  );
};

export default AdsSlot;
